import React, { useState } from "react";
import Modal from "components/modal";
import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import { useDispatch, useSelector } from "react-redux";
import { unAssignItem } from "store/containerSlice";

function UnAssignOrderModal({ isOpen, onClose, item, refreshList }) {
  const dispatch = useDispatch();
  const { unAssignLoading } = useSelector((state) => state.containers);

  const [confirmOpen, setConfirmOpen] = useState(true);

  const closeModal = () => {
    if (unAssignLoading) return;
    setConfirmOpen(false);
    onClose();
  };

  const handleUnassign = async () => {
    try {
      const response = await dispatch(
        unAssignItem({
          containerItemId: item._id,
          orderItemId: item?.orderItem?._id,
        })
      );
      if (response?.payload?.statuscode === 200) {
        closeModal();
        refreshList?.();
      } else {
        console?.error(response?.payload?.msg || "Unassign failed!");
      }
    } catch (err) {
      console.error("Unassign failed:", err);
    }
  };

  return (
    <Modal
      isOpen={isOpen && confirmOpen}
      onClose={closeModal}
      className="max-w-lg"
    >
      <h3 className="border-b py-3 pl-2 text-lg font-semibold text-navy-700 dark:text-white">
        Confirm Unassign
      </h3>

      <div className="p-4">
        <p className="text-sm text-gray-700 dark:text-gray-200">
          Are you sure you want to unassign this item from the order?
        </p>

        <div className="mt-5 flex items-center justify-end gap-2">
          <Button variant="outline" onClick={closeModal}>
            Cancel
          </Button>
          <LoaderButton isLoading={unAssignLoading} onClick={handleUnassign}>
            Yes, unassign
          </LoaderButton>
        </div>
      </div>
    </Modal>
  );
}

export default UnAssignOrderModal;
